/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import ListingPage from './ListingPage';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatBoolean } from '../util/Utils'
var homepage = require('../../package.json').homepage;


/**
 * Jobs page of web monitor.
 */
export default class Jobs extends Component {
    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    nameFormatter(name) {
        return <Link to={`${homepage}/jobDetail/${name}`}>{name}</Link>
    }


    render() {
        let columns = {
            'Name': 'id',
            'Domains': 'dom',
            '#Rcpt': 'rcp',
            '#KBytes': 'kb',
            'Paused': 'paused',
            'Scheduled Start Time': 'scheduledStartTime'
        }

        let columnFormatter = {
            Name: this.nameFormatter,
            Paused: formatBoolean
        }

        return (
            <ListingPage name='job'
                         defaultName='*'
                         urlPath='/jobs'
                         items='jobs'
                         columns={columns}
                         showError={this.props.showError}
                         columnFormatter={columnFormatter}
                         setRefresh={this.props.setRefresh}
                         setRefreshInterval={this.props.setRefreshInterval}/>
        );
    }
}
